import { render, staticRenderFns } from "./followTerminalAds.vue?vue&type=template&id=c9121ae6&scoped=true"
import script from "./followTerminalAds.vue?vue&type=script&lang=js"
export * from "./followTerminalAds.vue?vue&type=script&lang=js"
import style0 from "./followTerminalAds.vue?vue&type=style&index=0&id=c9121ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9121ae6",
  null
  
)

export default component.exports